// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0fec08e","239":"54b0faff","455":"abb235d7"}[chunkId] + ".chunk.js";
};